import { render } from "./HeaderSelecaoMeses.vue?vue&type=template&id=2faa6361&scoped=true"
import script from "./HeaderSelecaoMeses.vue?vue&type=script&lang=js"
export * from "./HeaderSelecaoMeses.vue?vue&type=script&lang=js"

import "./HeaderSelecaoMeses.vue?vue&type=style&index=0&id=2faa6361&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2faa6361"]])

export default __exports__